import {Api} from '../api/api';

class VoteLike
{
    /**
     * @param {Element} element
     */
    constructor(element) {
        this.container = element;
        this.afterVoteCallback = null;

        this.initListeners();
    }

    initListeners() {
        Array.from(this.container.querySelectorAll('[data-vote]')).forEach((element) => element.addEventListener('click', (event) => {
            event.preventDefault();
            this.vote(event.currentTarget);
        }));
    }

    /**
     * @param {CallableFunction} callback
     */
    setAfterVoteCallback(callback) {
        this.afterVoteCallback = callback;
    }

    /**
     * @param {Element} clickedButtonElement
     */
    vote(clickedButtonElement) {
        if (this.container.classList.contains('voted')) {
            let voteTooltipElement = this.container.querySelector('[data-vote="tooltip"]');

            if (voteTooltipElement) {
                voteTooltipElement.classList.remove('is-none');
                setTimeout(() => voteTooltipElement.classList.add('is-none'), 1000);
            }

            return;
        }

        let voteDirection = clickedButtonElement.getAttribute('data-vote');

        Api.put(this.container.getAttribute('data-endpoint'), {rating: voteDirection === 'up' ? 1 : 0}, () => {
            clickedButtonElement.classList.add('-touched');
            this.afterVote(voteDirection);
        });
    }

    /**
     * @param {String} voteDirection
     */
    afterVote(voteDirection) {
        let voteCountElement = this.container.querySelector(`[data-vote-count="${voteDirection}"]`);
        this.container.classList.add('voted');

        if (voteCountElement) {
            voteCountElement.textContent = String(Number(voteCountElement.textContent) + 1);
        }

        if (this.afterVoteCallback) {
            this.afterVoteCallback(voteDirection);
        }
    }
}

export {VoteLike};
